import { normalizeSocialLink } from "../utils";
import { SocialNetworkLinkItem } from "../types";

export function SocialNetworkItem({
  url,
  name,
  imgSrc,
  altText,
}: SocialNetworkLinkItem) {
  if (!url || !url.length) return null;

  return (
    <a href={normalizeSocialLink(name, url)} target="_blank" rel="noreferrer">
      <img src={imgSrc} alt={altText} />
    </a>
  );
}
